export function getPayeeByIdV4(send) {
  return (payeeId, query, ...args) =>
    send(
      {
        path: '/v4/payees/{payeeId}',
        pathParameters: { payeeId },
        type: 'get',
        query: query,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
